/**
 * Base path when deployed under a URL prefix (e.g. "/app").
 * Leave empty for root deploy at https://dealbeez.com/
 */
export const CDZ = "";

/** Absolute app path, e.g. cPath('stores') -> '/stores' */
export function cPath(sub) {
  if (!sub || sub === "/") return CDZ || "/";
  const clean = String(sub).replace(/^\//, "");
  const base = CDZ.replace(/\/$/, "");
  if (!base) return `/${clean}`;
  return `${base}/${clean}`;
}
